/* eslint-disable react/prop-types */
import React from 'react';

function Tag({ children, additionalClasses = '', bgColor = '#F3F4F6', textColor = '#fff', size = "small" }) {
  if (size === "large") {
    additionalClasses = additionalClasses + " text-[12px] w-14 h-[34px]";
  } else {
    additionalClasses = additionalClasses + " text-[10px] w-12 h-[30px]";
  }
  return (
    <div className={`font-secondary ml-[1px] rtl:ml-0 rtl:mr-[1px] leading-none stamp-border stamp-border-xs ${additionalClasses}`} style={{backgroundImage: `radial-gradient(2px, transparent 98%, ${bgColor}), linear-gradient(white 0 0)`, color: textColor}}>
      <div className="h-full text-center flex items-center justify-center" style={{backgroundColor: bgColor}}>
        {children}
      </div>
    </div>
  );
}

export default Tag;
